import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';

import { FieldConfig } from '../../models/common-models';
import { SlotTimeFormatter } from '../../../pipes/slot-time-formatter.pipe';

@Component({
  selector: 'app-form-autocomplete',
  templateUrl: './form-autocomplete.component.html',
  styleUrls: ['./form-autocomplete.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormAutocompleteComponent implements OnInit {
  @ViewChild('autoCompleteInput') autoCompleteInput: ElementRef<HTMLInputElement>;
  @ViewChild('trigger', { read: MatAutocompleteTrigger }) trigger: MatAutocompleteTrigger;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  public FormControlName;
  config: FieldConfig;
  group: FormGroup;
  selectedOptions: any = [];
  autocompleteOptions: any[];
  showErrorText: boolean = false;
  toHighlight: string;
  appearance: boolean;
  scroll:any;
  constructor(public _eR: ElementRef, public renderer: Renderer2,private slotTimePipe: SlotTimeFormatter) { }

  ngOnInit() {
    this.FormControlName = this.config.name;
    this.autocompleteOptions = this.config.options;
    this.appearance = this.config.appearance ? this.config.appearance : false;
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedOptions.push(event.option.viewValue);
    this.toHighlight = "";
    //this.autoCompleteInput.nativeElement.value = '';
    let x = this.FormControlName;
    this.group.patchValue({ x: '' })
    this.config.cellClick(event);
  }

  ngOnChanges() {
  }

  ngDoCheck(): void {
    // const panel = this.matAutocomplete.panel;
    // if (panel) {
    //   panel.nativeElement.parentElement.classList.add(this.config.panelClass);
    //   let a= panel.nativeElement.parentElement.parentElement.parentElement.children[0].outerHTML;
    //   if(a != '<div class="cdk-overlay-backdrop mat-overlay-transparent-backdrop cdk-overlay-backdrop-showing"></div>'){
    //     panel.nativeElement.parentElement.parentElement.insertAdjacentHTML('beforebegin','<div class="cdk-overlay-backdrop mat-overlay-transparent-backdrop cdk-overlay-backdrop-showing"></div>');
    //   }
    // }
  }

  iconClick(event) {
    //   this.trigger.openPanel();
    if (this.config.cellClick) {
      this.config.returnFunction(event);

    }

  }

  validInput(event) {
    // const panel = this.matAutocomplete.panel;
    // let a= panel.nativeElement.parentElement.parentElement.parentElement.children[0].outerHTML;
    // if(a == '<div class="cdk-overlay-backdrop mat-overlay-transparent-backdrop cdk-overlay-backdrop-showing"></div>'){
    //   panel.nativeElement.parentElement.parentElement.parentElement.children[0].remove();
    // }
    // let filterValue = this.group.value[this.FormControlName],
    // selectedOption = this.config.autoOptions.filter(option => option.value.toLowerCase() == filterValue.toLowerCase());
    // if(selectedOption.length < 1){
    //   this.showErrorText = true;
    //   this.config.value="";
    //   this.group.controls[this.FormControlName].setErrors({ 'incorrect': true, 'focused': false,'required': true });
    //   this.group.controls[this.FormControlName].markAsTouched();
    // }
    // else{
    //   this.group.controls[this.FormControlName].setErrors(null);
    //   this.showErrorText = false;
    //   this.config.value = this.selectedOptions;
    // }
  }
  filterOptions(event) {
    if (this.config.isDateTime) {
      this.autocompleteOptions = this.config.options.filter(option =>
        this.slotTimePipe.transform(option.DateTime).toLowerCase().includes(event.target.value.toLowerCase()));
    } else {
      const filterValue = event.target.value.toLowerCase();
      this.autocompleteOptions = this.config.options.filter(option => option.value.toLowerCase().indexOf(filterValue) != -1);
    }

  }
  scrollEvent = (event: any): void => {
   if(this.autocomplete.panelOpen){
     this.autocomplete.updatePosition();
   }
      // this.autocomplete.closePanel(); 
  };

  ngAfterViewInit() {
    this.autocompleteOptions = this.config.options;
  }
  ngDestroy(){
    window.removeEventListener('scroll', this.scrollEvent, true);
  }

  omit_Characters(event) {
    let key;
    key = event.charCode;
    return ((key > 47 && key < 58) || key == 45 || key == 46);
  }

  dateSelection(option) {
    this.config.cellClick(option);
  }
}
